import {
  IChatMessageModel,
  IMessagePayload,
  IMessage,
  ISocketEvent,
  MESSAGE_SOURCE,
} from "../interfaces/chat-message";
import axios from "axios";
import { BSON as Oid } from "realm-web";
import { io, Socket } from "socket.io-client";
import { appConfig } from "app/configs/appConfig";
import { getUrlParams } from "app/store/dataUtils";
import { usePopupStore } from "app/store/popupStore";
import { convertFieldsToDate } from "../utils/hooks";
import { useSocketStore } from "app/store/socketStore";
import { SocketService } from "../services/socket-manager";

const SocketEvents = {
  create: "message::create",
  fetch: "messages::fetch",
  updateSeen: "message::seen",
};

class ChatMessage implements IChatMessageModel {
  chatId: string;
  socket: Socket | null;
  socketURL: string;
  serverURL: string;
  events: ISocketEvent;

  // doc values.
  _id = new Oid.ObjectId();
  chat_id: null;
  deleted = false;
  seen = false;
  text = "";
  customer_supplier_id = "";
  source = MESSAGE_SOURCE.WAREHOUSE;
  created_at = new Date();
  seen_at = new Date(0);
  deleted_at = new Date(0);
  driver = "";
  warehouse = "";
  shipment = "";
  contains_images = false;

  constructor(messageValues?: Partial<IMessage>, _io?: Socket) {
    this.events = SocketEvents;
    this.socket = _io || useSocketStore.getState().messageSocket;
    this.socketURL =
      process.env.NODE_ENV === "development"
        ? appConfig.localChatSocketURL
        : appConfig.socketChatBaseURL;
    this.serverURL =
      process.env.NODE_ENV === "development"
        ? appConfig.localChatServerURL
        : appConfig.serverChatBaseURL;
    this.updateValues(messageValues);
  }

  updateValues = (newValues: Partial<IMessage>) => {
    const _values: Partial<IMessage> = convertFieldsToDate(newValues, [
      "created_at",
      "seen_at",
      "deleted_at",
    ]);

    for (let field in _values) {
      const val = newValues[field];
      if (val !== null) {
        switch (val) {
          case "_id":
          case "chat_id":
            if (typeof val == "string") this[field] = new Oid.ObjectID(val);
            else this[field] = val;
            break;
          default:
            this[field] = val;
            break;
        }
      }
    }
    return this;
  };

  get docValues(): Partial<IMessage> {
    return {
      _id: this._id || new Oid.ObjectId(),
      chat_id: this.chat_id,
      deleted: this.deleted,
      seen: this.seen,
      text: this.text,
      customer_supplier_id: this.customer_supplier_id,
      source: this.source,
      created_at: this.created_at,
      seen_at: this.seen_at,
      deleted_at: this.deleted_at,
      driver: this.driver,
      warehouse: this.warehouse,
      shipment: this.shipment,
      contains_images: this.contains_images,
    };
  }

  sendToSocket = async (event: string, payload?: any) => {
    const _io = new SocketService(this.chatId, this.shipment);
    _io?.emit(event, payload);
  };
  sendToEndpoint = async (type: "get" | "post", payload?: any) => {
    if (type === "post") {
      return (await axios.post(`${appConfig.serverChatBaseURL}`, payload)).data;
    }
    return (await axios.get(`${appConfig.serverChatBaseURL}`, payload)).data;
  };

  async makeRequest(event: string, type: "get" | "post", payload?: any) {
    if (!this.socket.connected) {
      return await this.sendToEndpoint(type, payload);
    }
    this.sendToSocket(event, payload);
  }

  async getChatsId(): Promise<string> {
    const { chatId, shipment, driver, warehouse } = getUrlParams();
    const { setChatIdFound } = usePopupStore.getState();
    if (chatId) {
      this.chatId = chatId;
      this.shipment = shipment;
      setChatIdFound(true);
      return chatId;
    } else {
      // const newChatId = (
      //     await axios.get(`${this.serverURL}/chat_id`, { params: { driver, warehouse, shipment } })
      // ).data;
      // if (newChatId) {
      //     this.chatId = newChatId;
      //     this.shipment = shipment;
      //     setChatIdFound(true);
      // }
      // return newChatId || "";
    }
  }

  async sendMessage() {
    await this.makeRequest(this.events.create, "post", {
      message: this.docValues,
    });
  }

  async fetchMessages() {
    return await this.makeRequest(this.events.fetch, "get", {
      // chat_id: this.chat_id,
      driver: this.driver,
      shipment: this.shipment,
      warehouse: this.warehouse,
    });
  }

  async updateMessageSeen(chat_id: string, shipment?: string) {
    if (this.socket) {
      return this.socket.emit(this.events.updateSeen, {
        chat_id,
        shipment: shipment || this.shipment || "",
        date: Date.now(),
      });
    }
    return (await axios.get(`${this.serverURL}`, { params: { chat_id } })).data;
  }
}

export { ChatMessage };
